<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Create new document type
      .row
        .columns
          label Name
            input(type="text", v-model="documentType.name")
          label Description
            input(type="text", v-model="documentType.description")
          label Attachment views
            .input-group(v-if="typeof documentType.attachment_views !== 'string'", v-for="(attachments, index) in documentType.attachment_views")
              input.input-group-field(type='text', v-model="documentType.attachment_views[index]")
              .input-group-button
                button.button.warning(@click="documentType.attachment_views.splice(index, 1)") -
          button.button.small(@click="documentType.attachment_views.push([])") Add view
        .columns
          .row
            .columns
              label Number required
              input(type="checkbox", v-model="documentType.has_number")
              br
              label Emission date required
              input(type="checkbox", v-model="documentType.has_emission")
              br
              label Expiry date required
              input(type="checkbox", v-model="documentType.has_expiry")
            .columns
              label Issuer required
              input(type="checkbox", v-model="documentType.has_issuer")
              br
              label Country required
              input(type="checkbox", v-model="documentType.has_country")

      .row.columns.text-center
        button.button(@click="save") Save Document Type
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'

  export default {
    name: 'CreateDocumentTypeButtonModal',
    components: {ModalReveal},
    data() {
      return {
        documentType: {
          name: null,
          description: null,
          attachment_views: [],
          has_number: true,
          has_emission: true,
          has_expiry: true,
          has_issuer: true,
          has_country: true,
        }
      }
    },
    created() {
    },
    methods: {
      save() {
        this.$set(this.documentType, 'attachment_views', this.documentType.attachment_views.join(','))

        KeplerBackofficeSdk.documentTypes.make(this.documentType, () => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateDocumentTypeButtonModal.vue?1ffa9775